import type { PortfolioItem } from "@/types/portfolio";

export type PortfolioFilterKey = "all" | "web" | "app";

export const PORTFOLIO_FILTERS: { key: PortfolioFilterKey; label: string }[] = [
  { key: "all", label: "전체" },
  { key: "web", label: "웹" },
  { key: "app", label: "앱" },
];

/** Filters portfolio items by platform (web/app); "all" returns everything. */
export function filterPortfolio(items: PortfolioItem[], filter: PortfolioFilterKey): PortfolioItem[] {
  if (filter === "all") return items;
  return items.filter((item) => item.platform.includes(filter));
}
